import React, { Component } from 'react';
import styled from 'styled-components';
import StyledButton from '@stelecom/ui-react/components/buttons/styledButton';
import RadioGroup from '@stelecom/ui-react/components/controls/radioGroup';

const RadioGroupContainer = styled.div`
    margin-bottom: 30px;
    width: 100%;
`;

class ChooseAddress extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selected: props.options ? props.options[0].value : null
        };
    }

    selectContract = value => this.setState({ selected: value })

    goNext = () => {
        const { options, next } = this.props;
        const selected = options.find(item => item.value == this.state.selected);
        next(selected.agreementNumber);
    }

    render() {
        const { selected } = this.state;
        const { options = [] } = this.props;
        return (
            <React.Fragment>
                <RadioGroupContainer>
                    <RadioGroup bordered={true} name='contract' options={options} selectedValue={selected} onChange={this.selectContract}></RadioGroup>
                </RadioGroupContainer>
                <StyledButton text='Далее' onClick={this.goNext}/>
            </React.Fragment>
        );
    }
}

export default ChooseAddress;
